import EventBus from '@/app/bus/event-bus';

export const switchPetMixins = {
	created() {
		EventBus.$on('petSwitched', this.refreshActivePetData);
	},
	beforeDestroy() {
		EventBus.$off('petSwitched', this.refreshActivePetData);
	}
}